"use client";
import {useEffect,useState} from 'react';
import {Clock3} from 'lucide-react';
import {formatBitePlanPrice} from '@/lib/bite-plan-price';
import pricing from '../../../../config/bite-plans.json';
type Plan='card'|'monthly';
type OfferPrice={amount:number;regularAmount:number};
export type BiteCompletionOffer={id:string;ticker:string;amount:number;regularAmount:number;plans:Record<Plan,OfferPrice>;expiresAt:number;serverNow:number;active:boolean;receivedAt?:number};
export const receiveBiteOffer=(offer:BiteCompletionOffer|null)=>offer?{...offer,receivedAt:performance.now()}:null;
export const offerRemaining=(offer:BiteCompletionOffer)=>Math.max(0,Math.ceil((offer.expiresAt-offer.serverNow-(performance.now()-(offer.receivedAt??performance.now())))/1000));
export const offerAmount=(offer:BiteCompletionOffer|null|undefined,plan:Plan)=>plan==='monthly'&&offer?.active&&offerRemaining(offer)>0?offer.plans[plan].amount:pricing.plans[plan].amount;
export function useOfferRemaining(offer?:BiteCompletionOffer|null){
  const [seconds,setSeconds]=useState(()=>offer?.active?offerRemaining(offer):0);
  useEffect(()=>{const tick=()=>setSeconds(offer?.active?offerRemaining(offer):0);tick();if(!offer)return;const timer=setInterval(tick,1000);return()=>clearInterval(timer);},[offer]);
  return seconds;
}
export const formatOfferCountdown=(seconds:number)=>[Math.floor(seconds/3600),Math.floor(seconds/60)%60,seconds%60].map(value=>String(value).padStart(2,'0')).join(':');
export function BiteCompletionOfferBanner({offer,showPrices=true}:{offer?:BiteCompletionOffer|null;showPrices?:boolean}) {
  const seconds=useOfferRemaining(offer);
  if(!offer)return null;
  return <section className="bite-completion-offer" aria-label="보고서 완성 할인">
    <h3 className="bite-completion-offer__heading">{seconds>0?<><span>지금부터 딱 1시간 동안,</span><strong>월간 패스 50% 할인!</strong></>:'1시간 할인이 종료됐습니다.'}</h3>
    {showPrices&&<div className="bite-completion-offer__prices">{(['monthly'] as const).map(plan=><p className="bite-completion-offer__price" key={plan}>
      <span>월간 패스 (매월)</span>
      {seconds>0&&<del>{formatBitePlanPrice(offer.plans[plan].regularAmount)}원</del>}
      <b>{formatBitePlanPrice(offerAmount(offer,plan))}원</b>
    </p>)}</div>}
    {seconds>0&&<strong className="bite-completion-offer__timer" role="timer" aria-live="off"><Clock3 aria-hidden="true"/>{formatOfferCountdown(seconds)} 남음</strong>}
  </section>;
}
